import React from 'react';
import PropTypes from 'prop-types';

// this is lightly adapted from react-download-link
// https://github.com/petermoresi/react-download-link
// https://github.com/petermoresi/react-download-link.git
export default class DownloadLink extends React.PureComponent {
  handleDownloadClick = (event) => {
    function magicDownload(text, fileName) {
      const blob = new Blob([text], {
        type: 'application/json;charset=utf8;',
      });

      // create hidden link
      const element = document.createElement('a');
      document.body.appendChild(element);
      element.setAttribute('href', window.URL.createObjectURL(blob));
      element.setAttribute('download', fileName);
      element.style.display = '';

      element.click();

      document.body.removeChild(element);
      event.stopPropagation();
    }

    const fileType = event.target.innerText;
    const text = this.props.exportFile(fileType);

    if (text instanceof Promise) {
      text.then(
        result => magicDownload(result, this.props.filename),
      );
    } else {
      magicDownload(text, this.props.filename);
    }
  }

  render() {
    return (
      <a
        style={this.props.style}
        title={this.props.title}
        className="stats-download btn btn-secondary btn-md"
        href="javascript:void(0)"
        onClick={this.handleDownloadClick}
      >
        {this.props.label}
      </a>
    );
  }
}

DownloadLink.propTypes = {
  filename: PropTypes.string,
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  style: PropTypes.object,
  exportFile: PropTypes.func,
};

DownloadLink.defaultProps = {
  filename: 'file.txt',
  label: 'Save',
  style: {},
  exportFile: () => {},
};
